import * as React from 'react';
import { connect } from 'react-redux';
import StylingLanding from './StylePages/StylingLanding/StylingLanding';
import KPDropDownPage from './StylePages/KPDropDownPage/KPDropDownPage';
import KPInputTextAreaPage from './StylePages/KPInputTextAreaPage/KPInputTextAreaPage';
import LookupsSubmit from './StylePages/LookupsSubmit/LookupsSubmit';
import ThirdPartyPage from './StylePages/ThirdPartyComponent/ThirdPartyPage';
import SelectableTilePage from './StylePages/SelectableTilePage/SelectableTilePage';
import KPSelectableListPage from './StylePages/KPSelectableListPage/KPSelectableListPage';
import KPNumberSelectorPage from './StylePages/KPNumberSelectorPage/KPNumberSelectorPage';
import KPClaimListPage from './StylePages/KPClaimListPage/KPClaimListPage';
import './StylingProjectMain.css';

class StartProcess extends React.Component<any, any>  {
    constructor(props) {
        super(props);
        this.handleNext = this.handleNext.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.changeStylingPage = this.changeStylingPage.bind(this);
        this.hideList = this.hideList.bind(this);
        this.state = {
            selectedStylingPage: "selectDefault",
            showAll: true,
        };
        this.setState({ selectedStylingPage: "selectDefault" });
    }

    async handleNextStep(e: any) {
        await this.props.dispatchHandleNextStep();
    }

    async handleNext(e: any) {
        await this.props.dispatchHandleNextStep();
    }

    async hideList(e: any) {
        await this.setState({ showAll: !this.state.showAll });
    }

    async changeStylingPage(whichStylingPageToDisplay) {
        await this.setState({ selectedStylingPage: whichStylingPageToDisplay });
    }

    public render() {
        return (
            <>
                <div className="ssp-styling-project-menu">
                    <fieldset className="ssp-styling-project-menu-fieldset">
                        {this.state.showAll &&
                            <>
                                <legend> SSP Styling Foundation Menu</legend>
                                <input type="button" onClick={() => this.changeStylingPage("selectDefault")} value="Styling Home" />
                                <input type="button" onClick={() => this.changeStylingPage("selectKPInputTextArea")} value="KP Input Text Area" />
                                <input type="button" onClick={() => this.changeStylingPage("selectKPDropDown")} value="KP Drop Down" />
                                <input type="button" onClick={() => this.changeStylingPage("select3rdParty")} value="Other party/parties button" />
                                <input type="button" onClick={() => this.changeStylingPage("selectLookupsSubmit")} value="Lookups" />
                                <input type="button" onClick={() => this.changeStylingPage("selectList")} value="List component" />
                                <input type="button" onClick={() => this.changeStylingPage("selectSelectableTile")} value="Selectable Tile" />
                                <input type="button" onClick={() => this.changeStylingPage("selectKPNumberInput")} value="Number Input" />
                                <input type="button" onClick={() => this.changeStylingPage("selectKPClaimList")} value="Claim List" />
                            </>
                        }
                        <input type="button" onClick={this.hideList} value="Hide" />
                    </fieldset>
                </div>
                {(this.state.selectedStylingPage === "selectLookupsSubmit") &&
                    <>
                        <LookupsSubmit />
                    </>
                }
                {(this.state.selectedStylingPage === "selectKPDropDown") &&
                    <>
                        <KPDropDownPage />
                    </>
                }
                {(this.state.selectedStylingPage === "selectKPInputTextArea") &&
                    <>
                        <KPInputTextAreaPage />
                    </>
                }
                {(this.state.selectedStylingPage === "selectDefault") &&
                    <>
                        <StylingLanding />
                    </>
                }
                {(this.state.selectedStylingPage === "select3rdParty") &&
                    <>
                        <ThirdPartyPage />
                    </>
                }
                {(this.state.selectedStylingPage === "FollowUpQuestions") &&
                    <>
                        <ThirdPartyPage />
                    </>
                }
                {(this.state.selectedStylingPage === "selectList") &&
                    <>
                        <KPSelectableListPage />
                    </>
                }
                {(this.state.selectedStylingPage === "selectSelectableTile") &&
                    <>
                        <SelectableTilePage/>
                    </>
                }
                {(this.state.selectedStylingPage === "selectKPNumberInput") &&
                    <>
                        <KPNumberSelectorPage />
                    </>
                }
                {(this.state.selectedStylingPage === "selectKPClaimList") &&
                    <>
                        <KPClaimListPage />
                    </>
                }
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile,
        TemplateData: state.TemplateData
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetTimeShow: () => dispatch(),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(StartProcess)